import { IHoliday } from "../holidayTypes";

export const NorwayHolidays: { [key: string]: IHoliday } = {
  // 2024
  "2024-01-01": { title: "Nyttårsdag", type: "HOLIDAY" },
  "2024-03-28": { title: "Skjærtorsdag", type: "HOLIDAY" },
  "2024-03-29": { title: "Langfredag", type: "HOLIDAY" },
  "2024-03-31": { title: "1. påskedag", type: "HOLIDAY" },
  "2024-04-01": { title: "2. påskedag", type: "HOLIDAY" },
  "2024-05-01": { title: "Arbeidernes dag", type: "HOLIDAY" },
  "2024-05-09": { title: "Kristi himmelfartsdag", type: "HOLIDAY" },
  "2024-05-17": { title: "Grunnlovsdagen", type: "HOLIDAY" },
  "2024-05-19": { title: "1. pinsedag", type: "HOLIDAY" },
  "2024-05-20": { title: "2. pinsedag", type: "HOLIDAY" },
  "2024-12-24": { title: "Julaften", type: "SPECIAL_DAY" }, // Inte en officiell helgdag
  "2024-12-25": { title: "1. juledag", type: "HOLIDAY" },
  "2024-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2024-12-31": { title: "Nyttårsaften", type: "SPECIAL_DAY" }, // Inte en officiell helgdag

  // 2025
  "2025-01-01": { title: "Nyttårsdag", type: "HOLIDAY" },
  "2025-04-10": { title: "Skjærtorsdag", type: "HOLIDAY" },
  "2025-04-11": { title: "Langfredag", type: "HOLIDAY" },
  "2025-04-13": { title: "1. påskedag", type: "HOLIDAY" },
  "2025-04-14": { title: "2. påskedag", type: "HOLIDAY" },
  "2025-05-01": { title: "Arbeidernes dag", type: "HOLIDAY" },
  "2025-05-17": { title: "Grunnlovsdagen", type: "HOLIDAY" },
  "2025-05-29": { title: "Kristi himmelfartsdag", type: "HOLIDAY" },
  "2025-06-08": { title: "1. pinsedag", type: "HOLIDAY" },
  "2025-06-09": { title: "2. pinsedag", type: "HOLIDAY" },
  "2025-12-24": { title: "Julaften", type: "SPECIAL_DAY" },
  "2025-12-25": { title: "1. juledag", type: "HOLIDAY" },
  "2025-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2025-12-31": { title: "Nyttårsaften", type: "SPECIAL_DAY" },

  // 2026
  "2026-01-01": { title: "Nyttårsdag", type: "HOLIDAY" },
  "2026-04-02": { title: "Skjærtorsdag", type: "HOLIDAY" },
  "2026-04-03": { title: "Langfredag", type: "HOLIDAY" },
  "2026-04-05": { title: "1. påskedag", type: "HOLIDAY" },
  "2026-04-06": { title: "2. påskedag", type: "HOLIDAY" },
  "2026-05-01": { title: "Arbeidernes dag", type: "HOLIDAY" },
  "2026-05-14": { title: "Kristi himmelfartsdag", type: "HOLIDAY" },
  "2026-05-17": { title: "Grunnlovsdagen", type: "HOLIDAY" },
  "2026-05-24": { title: "1. pinsedag", type: "HOLIDAY" },
  "2026-05-25": { title: "2. pinsedag", type: "HOLIDAY" },
  "2026-12-24": { title: "Julaften", type: "SPECIAL_DAY" },
  "2026-12-25": { title: "1. juledag", type: "HOLIDAY" },
  "2026-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2026-12-31": { title: "Nyttårsaften", type: "SPECIAL_DAY" },

  // 2027
  "2027-01-01": { title: "Nyttårsdag", type: "HOLIDAY" },
  "2027-03-25": { title: "Skjærtorsdag", type: "HOLIDAY" },
  "2027-03-26": { title: "Langfredag", type: "HOLIDAY" },
  "2027-03-28": { title: "1. påskedag", type: "HOLIDAY" },
  "2027-03-29": { title: "2. påskedag", type: "HOLIDAY" },
  "2027-05-01": { title: "Arbeidernes dag", type: "HOLIDAY" },
  "2027-05-06": { title: "Kristi himmelfartsdag", type: "HOLIDAY" },
  "2027-05-16": { title: "1. pinsedag", type: "HOLIDAY" },
  "2027-05-17": { title: "Grunnlovsdagen / 2. pinsedag", type: "HOLIDAY" },
  "2027-12-24": { title: "Julaften", type: "SPECIAL_DAY" },
  "2027-12-25": { title: "1. juledag", type: "HOLIDAY" },
  "2027-12-26": { title: "2. juledag", type: "HOLIDAY" },
  "2027-12-31": { title: "Nyttårsaften", type: "SPECIAL_DAY" },
};



// WEBPACK FOOTER //
// ./src/constants/holidays/europe/norwayHolidays.ts